module.exports = __webpack_public_path__ + "static/media/Picture2.2681a144.jpg";